import type { ActivitySourceName } from '../types/activity-source'

export abstract class ActivitySource {
  abstract readonly name: ActivitySourceName

  private onActivity: (() => void) | null = null

  subscribe(onActivity: () => void): void {
    if (this.onActivity) {
      this.teardown()
    }
    this.onActivity = onActivity
    this.setup()
  }

  unsubscribe(): void {
    this.teardown()
    this.onActivity = null
  }

  protected abstract setup(): void
  protected abstract teardown(): void

  protected notify(): void {
    this.onActivity?.()
  }
}
